export interface TblDecInvProyectoTesistum {
    iddecinvproyectotesista: number,
    iddecinvproyecto: number,
    codEstudiante: string,
    anio: string,
    termino: string,
    fechasolicitud: Date,
    codCarrera: string,
    codEspecializ: string,
    codDivision: string,
    codUnidad: string,
    objgeneral: string,
    mailtutor: string,
    nombretutor: string,
    titulo: string,
    comentario: string,
    temainv: string,
    resultados: string,
    productos: string,
    codigomateria: string,
    itinerariocompleto: string,
    tipo: string,
    estado: string,
}

export function VoidTblDecInvProyectoTesistum(): TblDecInvProyectoTesistum {
    return {
        iddecinvproyectotesista: 0,
        iddecinvproyecto: 0,
        codEstudiante: '',
        anio: '',
        termino: '',
        fechasolicitud: new Date(),
        codCarrera: '',
        codEspecializ: '',
        codDivision: '',
        codUnidad: '',
        objgeneral: '',
        mailtutor: '',
        nombretutor: '',
        titulo: '',
        comentario: '',
        temainv: '',
        resultados: '',
        productos: '',
        codigomateria: '',
        itinerariocompleto: '',
        tipo: 'I',
        estado: 'P',
    };
 
}

export function setTblDecInvProyectoTesistum(data: any): TblDecInvProyectoTesistum {
    return {
      iddecinvproyectotesista: data.iddecinvproyectotesista ?? 0,
      iddecinvproyecto: data.iddecinvproyecto ?? 0,
      codEstudiante: data.codestudiante ?? '',
      anio: data.anio ?? '',
      termino: data.termino ?? '',
      fechasolicitud: data.fechasolicitud ?? new Date(),
      codCarrera: data.codcarrera ?? '',
      codEspecializ: data.codespecializ ?? '',
      codDivision: data.coddivision ?? '',
      codUnidad: data.codunidad ?? '',
      objgeneral: data.objgeneral ?? '',
      mailtutor: data.mailtutor ?? '',
      nombretutor: data.nombretutor ?? '',
      titulo: data.titulo ?? '',
      comentario: data.comentario ?? '',
      temainv: data.temainv ?? '',
      resultados: data.resultados ?? '',
      productos: data.productos ?? '',
      codigomateria: data.codigomateria ?? '',
      itinerariocompleto: data.itinerariocompleto ?? '',
      tipo: data.tipo ?? '',
      estado: data.estado ?? ''
    };
  }